export interface ChainConfig {
  chainId: string;
  chainName: string;
  nativeCurrency: {
    name: string;
    symbol: string;
    decimals: number;
  };
  rpcUrls: string[];
  blockExplorerUrls?: string[];
}

export interface WalletInfo {
  address: string;
  chainId: string;
  provider: any;
  isConnected: boolean;
  walletType: WalletType;
}

export enum WalletType {
  METAMASK = 'metamask',
  BINANCE = 'binance',
  WALLETCONNECT = 'walletconnect',
  TRUST = 'trust',
  UNKNOWN = 'unknown'
}

export interface TransactionRequest {
  to: string;
  value?: string;
  data?: string;
  gasLimit?: string;
  gasPrice?: string;
  nonce?: number;
}

export interface ConnectOptions {
  chainId?: string;
  walletType?: WalletType;
  projectId?: string;  // WalletConnect project ID
  showQrModal?: boolean;
  qrModalOptions?: any;
}

export interface WalletConnectConfig {
  chains?: ChainConfig[];
  defaultChain?: string;
  projectId?: string;
  metadata?: {
    name: string;
    description: string;
    url: string;
    icons: string[];
  };
  autoConnect?: boolean;
}

export interface IWalletAdapter {
  connect(options?: ConnectOptions): Promise<WalletInfo>;
  disconnect(): Promise<void>;
  getAccount(): Promise<string | null>;
  getChainId(): Promise<string | null>;
  switchChain(chainId: string): Promise<void>;
  sendTransaction(tx: TransactionRequest): Promise<string>;
  signMessage(message: string): Promise<string>;
  isConnected(): boolean;
  onAccountsChanged(callback: (accounts: string[]) => void): void;
  onChainChanged(callback: (chainId: string) => void): void;
  onDisconnect(callback: () => void): void;
}